import React from "react";

/** Light-blue background with a white shield containing a red emblem */
export const RiskZoneIcon: React.FC = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#0EA5E9" />
    {/* Outer white shield */}
    <path
      d="M20 7 L31 12 L31 22 C31 29 26 33.5 20 35.5 C14 33.5 9 29 9 22 L9 12 Z"
      fill="white"
    />
    {/* Red inner shield / emblem */}
    <path
      d="M20 11 L27.5 14.5 L27.5 22 C27.5 27 24 30 20 31.5 C16 30 12.5 27 12.5 22 L12.5 14.5 Z"
      fill="#EF4444"
    />
    {/* White cross inside red area */}
    <rect x="18.5" y="15.5" width="3" height="10" rx="1.25" fill="white" />
    <rect x="14.5" y="19"   width="11" height="3"  rx="1.25" fill="white" />
  </svg>
);
